import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=64387350"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports